import { Card, Grid, Typography } from "@material-ui/core";
import Divider from "../../common/divider";
import ctMap from '../../common/images/outside/ct_map.png';
import ImageWrapper from "../../common/imageWrapper";

const HomepageHours = () => {
  return (
      <Grid container justify="center" style={{ marginTop: '100px' }}>
        <Grid item xs={12} sm={10} md={10}>
        <Card style={{ borderTop: '4px inset #1d1d1d', padding: '20px 20px 10px 20px', backgroundColor: 'whitesmoke' }}>
        <Grid container justify="space-around">

          <Grid item sm={12} md={6}>
            <Grid container spacing={1}>
              <Grid item xs={12}><Typography variant="h4">Find Us</Typography></Grid>
                <Grid item sm={12}>
                  <Grid container>
                    <Grid item xs={1}>
                      <Typography variant="h6" style={{ fontSize: '19px', writingMode: 'vertical-rl', transform: 'rotate(-180deg)' }}>
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://www.google.com/maps/dir//41.5886537,-85.8438648/@41.588292,-85.844023,18z?hl=en-US"
                        >
                          231 Chicago Ave. Goshen, IN 46526
                        </a>
                      </Typography>
                    </Grid>
                    <Grid item xs={11}>
                      <div
                        style={{
                          backgroundImage: `url(${ctMap})`,
                        }}
                        className="ct_map"
                        onClick={() => window.open('https://www.google.com/maps/dir//41.5886537,-85.8438648/@41.588292,-85.844023,18z?hl=en-US')}
                      />

                    </Grid>
                  </Grid>
                </Grid>

              <Grid item xs={12}>
                <Divider />
              </Grid>

              <Grid item xs={12} style={{ marginTop: '20px' }}>
                <Typography variant="h4">Hours*</Typography>
              </Grid>

              <Grid item xs={6}><Typography variant="body1"><b>Mon - Fri:</b> 11am - 7pm</Typography></Grid>
              <Grid item xs={6}><Typography variant="body1"><b>Saturday:</b> 8am - 4pm</Typography></Grid>
              <Grid item xs={6}><Typography variant="body1"><b>Sunday:</b> Closed</Typography></Grid>

              <Grid item sm={6} xs={12}><Typography variant="body2" style={{ paddingBottom: '10px' }}>*Hours subject to change on holidays and per staffing issues.</Typography> </Grid>

            </Grid>
          </Grid>

          <Grid item xs={12} md={3}>
            <Grid item xs={12}><Typography variant="h4">Follow Us</Typography></Grid>
            <Grid item xs={12}>
              <iframe
                src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FCastanedaTacosAndRestaurant&tabs=timeline&width=340&height=500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                width="340"
                height="500"
                style={{ border: '2px inset #caab0e', overflow: 'hidden', scrolling: 'no', frameBorder: 0 }}
                allowFullScreen
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
              />
            </Grid>
          </Grid>

        </Grid>
        </Card>
        </Grid>
      </Grid>
  );
};

export default HomepageHours;

// <iframe
//   src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FCastanedaTacosAndRestaurant&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
//   width="340"
//   height="500"
//   style={{ border: 'none', overflow: 'hidden', scrolling: 'no', frameBorder: 0 }}
//   // style="border:none;overflow:hidden" scrolling="no" frameBorder="0"
//   allowFullScreen
//   allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" />
